import {AddressContent} from 'components/Identity';

export const Address = () => <AddressContent />;
